import { get } from 'svelte/store';
import { store } from './store';
import areasData from '$lib/data/generated/content/settings/areas/data.json';

import { slugify } from "cando-util";

export const getAreas = () => {
	const currentStore = get(store);
	const storeAreaDocs = { ...currentStore?.settings?.docs?.areas };
	const contentAreaDocs = { ...areasData };

	const areaDocs = { ...storeAreaDocs, ...contentAreaDocs };

	const areaKeys = Object.keys(areaDocs || {}).filter(k => k !== 'index');
	const areas = areaKeys.map((k) => ({ [slugify(areaDocs[k].value.label.value)]: { ...areaDocs[k] } })).reduce((a, v) => ({ ...a, ...v }), {});
	const areaLabels = Object.entries(areaDocs).map(([k, v]) => v?.value?.label?.value).filter(v => !!v);
	const areaSlugs = areaLabels.map(area => slugify(area));
	const defaultArea = Object.entries(areaDocs).filter(([k, v]) => v?.value?.default?.value === 'true').map(([k, v]) => v?.value?.label?.value)[0];
	const defaultAreaSlug = slugify(defaultArea);

	return { areaKeys, areas, areaLabels, areaSlugs, defaultArea, defaultAreaSlug };
};
